module.exports = __webpack_public_path__ + "static/media/icons_Bilan lombaire TMO.0893298a.svg";